import React from 'react';
/*
import {
  hf,
  cr,
  gs,
  ls,
  a,
  BoxC,
  BtnC,
  GridC,
  LblC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as hf from './_hf';
import * as _ht from './_ht';

import * as icm from './icm';
import * as icv from './icv';

//import * as icvI1z___Ti2 from './icvI1z___Ti2';
import * as icvI1z___Ti from './icvI1z___Ti';

import * as icvBaseS10Rz from './icvBaseS10Rz';
/*

import * as icvHomeS11To from './icvHomeS11To';
import * as icvHomeS12To from './icvHomeS20Rz';
import * as icvHomeS13To from './icvHomeS30Rz';
*/

const $pagez = {} as _ht.dz; // 仮押表示用

export const N = () => {

  const _gUserz = gs.useUserz();
  
  const _udtThis = ls.udtThis();

  const _sPz = ls.usePz();

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _udtThis,
/*
    atrAsync: () => {
      icvI1z___Ti.ilzPagez($pagez);
      _sPz.udtAll();
    },
*/
  });

//hf.l(`icvHomeS10Rz 39: here`);
  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        bHome: false,
        pageName: 'メニュー',
      },
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
//          boxStlz: a(`dw/120 f/1 fd/cac mt/1`),
          boxStlz: a(`dw/f dwx/s15 f/1 fd/cac ph/1 mt/1`),
          oClds: [

            cr.c(LblC.N, {
              key: -10,
              abtType: 'barHdrCmnz',
              boxStlz: a(`f/n`),
              lblCz: {
//                boxStlz: a(`mb/1`),
                boxStlz: a(`bc/t bwb/1 mb/2`),
                textz: {
//                  pfx: '部屋の予約'
                  pfx: ''
                }
              },
              cttCz: {
                oClds: [
                  cr.c(GridC.N, {
                    key: -10,
                    abtType: 'nolineCmnz',
                    lineCs: [
                      {
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('12112') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
//                                boxStlz: a(`sc/gn5`),
                                lblCz: {
                                  textz: {
                                    pfx: 'エントリー状況'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.openUrl({
//                                      url: `${icv.appz.urlw}/stt?c=e&i=${_gUserz.crt._31rz._icn}&a=2`,
                                      url: `${icv.appz.urlw}/stt?c=e&d=${hf.cvtNbr('e', _gUserz.crt._dmn, icv.srtz.nbrz4)}&i=${hf.cvtNbr('e', _gUserz.crt._31rz._icn, icv.srtz.nbrz4)}&a=2`,
                                    });
                                  }
                                },
                              })
                              : undefined,
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('12111') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                lblCz: {
                                  textz: {
                                    pfx: 'エントリー'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvI1zS10RzE',
                                    });
                                  }
                                },
                              })
                              : undefined,
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
/* 20231205 削除 オフライン抽選
                              icm.chkPmn('12211') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                lblCz: {
                                  textz: {
                                    pfx: 'エントリー抽選'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvI1yS10Rz',
                                    });
                                  }
                                },
                              })
                              : undefined,
*/
                            ],
                          },
                        ]
                      },
                      {
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('11014') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/gn5`),
                                lblCz: {
                                  textz: {
                                    pfx: '予約状況'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.openUrl({
                                      url: `${icv.appz.urlw}/stt?c=r&d=${hf.cvtNbr('e', _gUserz.crt._dmn, icv.srtz.nbrz4)}&i=${hf.cvtNbr('e', _gUserz.crt._31rz._icn, icv.srtz.nbrz4)}&a=0`,
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('11011') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/gn5`),
                                lblCz: {
                                  textz: {
                                    pfx: '予約'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvI1zS10RzR',
                                    });
                                  }
                                },
                              })
                              : undefined,
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              _gUserz.crt.i19rz?.i19ra2110i == 1 &&
                              icm.chkPmn('19111') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/gn3`),
                                lblCz: {
                                  textz: {
                                    pfx: 'メール送信',
                                    stlz: a(`tc/lt9`),
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icv_70S10Rz',
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                        ]
                      },
                    ]
                  }),
                ]
              }
            }),

            cr.c(LblC.N, {
              key: -20,
              abtType: 'barHdrCmnz',
              boxStlz: a(`f/n`),
              lblCz: {
//                boxStlz: a(`mb/1`),
                boxStlz: a(`bc/lt3 bwb/1 mb/2`),
                textz: {
//                  pfx: '施設・システムの管理'
                  pfx: ''
                }
              },
              cttCz: {
                oClds: [
                  cr.c(GridC.N, {
                    key: -10,
                    abtType: 'nolineCmnz',
                    lineCs: [
                      {
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('11015') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/lt6`),
                                lblCz: {
                                  textz: {
                                    pfx: '使用状況',
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvI1zS30Rz',
                                    });
                                  }
                                },
                              })
                              : undefined,
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('2z111') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/lt6`),
                                lblCz: {
                                  textz: {
                                    pfx: '団体登録'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvI18S10Rz',
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('dld') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/lt6`),
                                lblCz: {
                                  textz: {
                                    pfx: 'データダウンロード'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvHomeS20Rz',
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                        ]
                      },
                      {
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('2z211') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/lt6`),
                                lblCz: {
                                  textz: {
                                    pfx: '休館日設定'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
/*
                                    cr.openUrl({
                                      url: `${icv.appz.urlw}/sng`
                                    })
*/
                                    cr.moveTo({
                                      pageName: 'icv_61S10Rz',
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('11016') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/lt6`),
                                lblCz: {
                                  textz: {
                                    pfx: 'サイネージ'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.openUrl({
                                      //url: `${icv.appz.urlw}/sng`
                                      url: `${icv.appz.urlw}/sng?c=r&d=${hf.cvtNbr('e', _gUserz.crt._dmn, icv.srtz.nbrz4)}&i=${hf.cvtNbr('e', _gUserz.crt._31rz._icn, icv.srtz.nbrz4)}`, // 共通化が必要か
                                    })
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc`),
                            oClds: [
                              icm.chkPmn('stg') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                boxStlz: a(`sc/lt4`),
                                lblCz: {
                                  textz: {
                                    pfx: 'システム設定'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
/*
                                    cr.moveTo({
                                      pageName: 'icvHomeS30Rz',
                                    })
*/
                                    cr.moveTo({
                                      pageName: 'icvHomeS40Rz',
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                        ]
                      },
                    ]
                  }),
                ]
              }
            }),

            icm.chkPmn('11014') ?
            cr.c(LblC.N, {
              key: -30,
              abtType: 'barHdrCmnz',
//              boxStlz: a(`f/n`),
              boxStlz: a(`f/1`),
              lblCz: {
//                boxStlz: a(`mb/1`),
                boxStlz: a(`bc/lt3 bwb/1 mb/3`),
                textz: {
//                  pfx: '仮押中の予約',
                  pfx: '',
                }
              },
              cttCz: {
//                boxStlz: a(`dh/10`),
                boxStlz: a(`f/1`),
                oClds: [
                  cr.c(TextC.N, {
                    key: -10,
                    textz: {
                      pfx: '仮押中の予約',
                      stlz: a('tb tc/lt9 ts/xl'),
                    },
                    boxStlz: a('dw/f fd/ccc mb/1'),
                  }),
                  cr.c(icvI1z___Ti.L, {
                    key: -20,
                    sPz: _sPz,
                    frcUdt: _udtThis,
                    cz: {
//                      i1zrs1100i: 70,
                      bHome: true,
                    },
                    pagez: $pagez,
                  }),
                ]
              }
            })
            : undefined,


          ]
        })

      ]
    })
  );
};
